import { S } from "./Squaremap.js";
import L from "leaflet";

class UILink {
    /**
     * @param {Settings_UI_Link} json
     * @param {boolean} show
     */
    constructor(json, show) {
        const Link = L.Control.extend({
            _container: null,
            options: {
                position: "bottomleft",
            },
            onAdd: function () {
                const link = L.DomUtil.create("button", "leaflet-control-layers link");
                link.type = "button";
                link.title = "Link naar deze plek kopiëren";
                link.setAttribute("aria-label", "Link naar deze plek kopiëren");
                this._link = link;
                this._link.innerHTML =
                    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m10 13 4-4m-6 7-1 1a4 4 0 0 1-6-6l4-4a4 4 0 0 1 6 0m2 3 1-1a4 4 0 0 1 6 6l-4 4a4 4 0 0 1-6 0" transform="translate(1 -1)"/></svg>';
                L.DomEvent.disableClickPropagation(link);
                this._link.onclick = async () => {
                    const url = S.worldList.curWorld == null ? "" : S.getUrlFromView();
                    window.history.replaceState(null, "", url);
                    try {
                        await navigator.clipboard.writeText(window.location.href);
                        link.title = "Link gekopieerd!";
                        link.setAttribute("aria-label", "Link gekopieerd!");
                    } catch {
                        link.title = "Kopieer de link uit de adresbalk";
                        link.setAttribute("aria-label", "Kopieer de link uit de adresbalk");
                    }
                };
                if (!show) {
                    this._link.style.display = "none";
                }
                return link;
            },
        });
        this.showLinkButton = show;
        this.link = new Link();
        S.map.addControl(this.link);
        if (!json.enabled) {
            this.link._link.style.display = "none";
        }
    }
}

export { UILink };
